import { ArrowLeftIcon } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { PlusIcon } from "@phosphor-icons/react/dist/csr/Plus";
import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { IconButtonWithTooltip } from "@/payroll/ai-script/icon-button-with-tooltip";

export const CHAT_PANEL_ICON_BUTTON_CLASS = "size-8 min-w-8 text-subtle";

interface ChatPanelHeaderProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  onNewChat?: () => void;
  onClose?: () => void;
  actions?: ReactNode;
}

export const ChatPanelHeader = ({
  title,
  subtitle,
  onBack,
  onNewChat,
  onClose,
  actions,
}: ChatPanelHeaderProps) => (
  <div className="flex h-14 shrink-0 items-center gap-1 border-b px-3">
    {onBack && (
      <IconButtonWithTooltip
        label="All chats"
        onClick={onBack}
        className={CHAT_PANEL_ICON_BUTTON_CLASS}
      >
        <ArrowLeftIcon />
      </IconButtonWithTooltip>
    )}
    <Stack gap={0} align="stretch" className="min-w-0 flex-1 px-1">
      <h2 className="truncate text-sm font-medium" title={title}>
        {title}
      </h2>
      {subtitle && (
        <p className="truncate text-xs text-subtle" title={subtitle}>
          {subtitle}
        </p>
      )}
    </Stack>
    <Stack direction="row" align="center" gap={0} className="shrink-0">
      {actions}
      {onNewChat && (
        <IconButtonWithTooltip
          label="New chat"
          onClick={onNewChat}
          className={CHAT_PANEL_ICON_BUTTON_CLASS}
        >
          <PlusIcon />
        </IconButtonWithTooltip>
      )}
      {onClose && (
        <IconButtonWithTooltip
          label="Close"
          onClick={onClose}
          className={CHAT_PANEL_ICON_BUTTON_CLASS}
        >
          <XIcon />
        </IconButtonWithTooltip>
      )}
    </Stack>
  </div>
);
